import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Input } from 'antd';
import { mpSearchData } from '../../utils/mp_search_data';
import { getQuery } from '../../utils';
import styles from './index.module.scss';

const { Search } = Input;

function Index() {

  const history = useHistory();
  const { pathname } = useLocation();
  const keyword = getQuery('keyword', history);

  const {
    headData,
    nickName
  } = useSelector(state => state.commonReducer);

  const {
    categorys
  } = useSelector(state => state.searchReducer);

  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    const _pathname = pathname.replace(/\//g,'');
    if (window.location.pathname.indexOf('list.html') !== -1 || window.location.hostname === 'list.jd.hk') {
      setSearchValue(categorys?.[1]?.cid3[0]?.name)
    } else if (_pathname.toLowerCase() === 'search') {
      setSearchValue(keyword)
    }
  }, [keyword, categorys, pathname])

  const onSearch = (value) => {
    value = !value ? (headData.placeHolderText || "一站尽享进口好物") : value;
    setSearchValue(value);
    if(window.location.hostname === 'list.jd.hk' || window.location.pathname.indexOf('list.html') !== -1){
      const origin = window.location.origin.replace('list.jd.hk', 'search.jd.hk');
      window.location.href = `${origin}/Search?keyword=${value}`;
    }else{
      history.push(`/Search?keyword=${value}`);
    }
  }

  const cartClick = (e) => {
    e.stopPropagation();
    const url = headData?.indexCart?.linkText;
    window.open(!nickName ? `//passport.jd.com/new/login.aspx?ReturnUrl=${encodeURIComponent(url)}` : url);
  }

  return (
    <div className={`w ${styles.rlt}`}>
      <div className={styles["logo-head"]}>
        <a 
          href={headData?.indexLogo?.linkText} 
          alt="京东海囤全球" 
          className={styles.logo} 
          style={headData?.indexLogo?.imgLogo ? { backgroundImage: `url(${headData?.indexLogo?.imgLogo})` } : {}} 
          clstag={mpSearchData.searchInput.logo}
        >
          京东海囤全球
        </a>
      </div>
      <div style={{ display: 'flex' }}>
        <div className={styles["search-2014"]}>
          <Search
            placeholder={headData.placeHolderText || "一站尽享进口好物"}
            enterButton={<span clstag={mpSearchData.searchInput.searchbutton}>搜索</span>}
            size="large"
            onSearch={onSearch}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <div className={styles["hotwords-2014"]}>
            {
              headData?.searchKeyWords?.map((searchKeyWord, searchKeyWordIdx) => <a key={`${searchKeyWord.text}-${searchKeyWordIdx}`} className={styles["style-red"]} href={searchKeyWord.linkText}>{searchKeyWord.text}</a>)
            }
          </div>
        </div>
        <div className={styles["settleup-2014"]}>
          <button className={styles["cw-icon"]} onClick={cartClick}>
            {
              headData?.indexCart?.imgLogo && <i className={styles["ci-left"]} style={{ backgroundImage: `url(${headData?.indexCart?.imgLogo})`}}></i>
            }
            <span>我的购物车</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default Index;